
























import { Component } from 'vue-property-decorator';

import Page from '@/componentsV2/molecules/Page/Page.vue';
import IntegrationsActivationEmailsList from '@/componentsV2/templates/IntegrationsActivationEmailsList/IntegrationsActivationEmailsList.vue';
import BillingModel from '../Models/BillingModel.vue';

@Component({
  components: {
    Page,
    IntegrationsActivationEmailsList
  }
})
export default class ActivationEmails extends BillingModel {
  emptyState = true;
  loading = false;

  get title() {
    return this.$t(`${this.tPrefix}.title`);
  }

  get tPrefix() {
    return 'emailAutomation';
  }

  get business() {
    return this.$store.getters['business/getBusinessInfo'].business || {};
  }

  changeEmptyState(value: boolean) {
    this.emptyState = value;
  }
}
